export default __webpack_public_path__ + "static/media/assorted-clump-pause.5ab84a9b.png";